import styled from 'styled-components';
import { Bones } from '@/components/Bones';

export const RiskRewardSentenceRow = styled('div')`
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  height: ${({ theme }) => theme.x3spacePx}px;
  width: 100%;
  display: flex;
`;

export const RiskRewardIconSkeleton = styled(Bones)`
  margin-left: ${({ theme }) => theme.x1spacePx - 4}px;
  width: ${({ theme }) => theme.x2spacePx}px;
  height: ${({ theme }) => theme.x2spacePx}px;
  border-radius: 9999px;
`;

export const RiskRewardTextSkeleton = styled(Bones)`
  margin-left: ${({ theme }) => theme.x1spacePx + 4}px;
  width: 80%;
  border-radius: 9999px;
`;
